import { iconFactory } from '../iconFactory'

export interface CheckboxProps {
  fill?: string
  type?: 'checked' | 'unchecked' | 'indeterminate'
}

export const Checkbox = iconFactory(
  'Checkbox',
  ({ fill, type }: CheckboxProps) => {
    switch (type) {
      case 'checked':
        return (
          <path
            d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM10.71 16.29C10.32 16.68 9.69 16.68 9.3 16.29L5.71 12.7C5.52275 12.5132 5.41751 12.2595 5.41751 11.995C5.41751 11.7305 5.52275 11.4768 5.71 11.29C6.1 10.9 6.73 10.9 7.12 11.29L10 14.17L16.88 7.29C17.27 6.9 17.9 6.9 18.29 7.29C18.68 7.68 18.68 8.31 18.29 8.7L10.71 16.29Z"
            fill={fill}
          />
        )

      case 'indeterminate':
        return (
          <path
            d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19ZM7 11H17V13H7V11Z"
            fill={fill}
          />
        )

      case 'unchecked':
      default:
        return (
          <path
            d="M19 5V19H5V5H19ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3Z"
            fill={fill}
          />
        )
    }
  },
)
